/** Stable permission strings; roles map to these in the database (see prisma/seed.ts). */
export const PERMISSIONS = {
    PRICING_READ: 'pricing:read',
    PRICING_COSTS: 'pricing:costs',
    PRICING_WRITE: 'pricing:write',
    PRICING_APPROVE: 'pricing:approve',
    OPERATIONS_READ: 'operations:read',
    OPERATIONS_CONFIGURE: 'operations:configure',
    RETURNS_READ: 'returns:read',
    RETURNS_WRITE: 'returns:write',
    RETURNS_INSPECT: 'returns:inspect',
    RETURNS_APPROVE: 'returns:approve',
    RETURNS_REFUND: 'returns:refund',
    PICKING_READ: 'picking:read',
    PICKING_WRITE: 'picking:write',
    PICKING_OVERRIDE: 'picking:override',
    INVENTORY_CLOSE: 'inventory:close',
    TOURS_READ: 'tours:read',
    TOURS_WRITE: 'tours:write',
    TOURS_DRIVE: 'tours:drive',
    CONTAINERS_READ: 'containers:read',
    CONTAINERS_WRITE: 'containers:write',
    CONTAINERS_CORRECT: 'containers:correct',
    EINVOICE_READ: 'einvoice:read',
    EINVOICE_EXPORT: 'einvoice:export',
    EINVOICE_IMPORT: 'einvoice:import',
    EINVOICE_SETTINGS: 'einvoice:settings',
    INTRODUCTION_MANAGE: 'introduction:manage',
    INTRODUCTION_RESET: 'introduction:reset',
    FEATURES_READ: 'features:read',
    FEATURES_MANAGE: 'features:manage',
    GLOBAL_SEARCH_USE: 'global_search:use',
    VAT_VALIDATION_READ: 'vat_validation:read',
    VAT_VALIDATION_EXECUTE: 'vat_validation:execute',
    VAT_VALIDATION_MANAGE: 'vat_validation:manage',
    DUNNING_READ: 'dunning:read',
    DUNNING_PREPARE: 'dunning:prepare',
    DUNNING_APPROVE: 'dunning:approve',
    DUNNING_SEND: 'dunning:send',
    DUNNING_CANCEL: 'dunning:cancel',
    DUNNING_MANAGE_SETTINGS: 'dunning:manage_settings',
    PORTAL_ACCESS_MANAGE: 'portal_access:manage',
    PORTAL_ORDERS_REVIEW: 'portal_orders:review',
    PORTAL_ACTIVITY_READ: 'portal_activity:read',
    CUSTOMER_READ: 'customer:read',
    CUSTOMER_WRITE: 'customer:write',
    CUSTOMER_DELETE: 'customer:delete',
    PARTNER_RISK_VIEW: 'partner_risk:view',
    PARTNER_RISK_SET_LOCK: 'partner_risk:set_lock',
    PARTNER_RISK_OVERRIDE_LOCK: 'partner_risk:override_lock',
    PRODUCT_READ: 'product:read',
    PRODUCT_WRITE: 'product:write',
    PRODUCT_DELETE: 'product:delete',
    INVENTORY_READ: 'inventory:read',
    INVENTORY_WRITE: 'inventory:write',
    DOCUMENT_READ: 'document:read',
    DOCUMENT_WRITE: 'document:write',
    DOCUMENT_SEND: 'document:send',
    DOCUMENT_TAX_OVERRIDE: 'document:tax_override',
    DOCUMENT_CUSTOMER_HEADER_READ: 'document_customer_header:read',
    DOCUMENT_CUSTOMER_HEADER_READ_INTERNAL: 'document_customer_header:read_internal',
    DOCUMENT_CUSTOMER_HEADER_EDIT_VALUES: 'document_customer_header:edit_values',
    DOCUMENT_CUSTOMER_HEADER_REFRESH_VALUES: 'document_customer_header:refresh_values',
    DOCUMENT_CUSTOMER_HEADER_CUSTOMIZE_LAYOUT: 'document_customer_header:customize_layout',
    DOCUMENT_CUSTOMER_HEADER_MANAGE_LAYOUTS: 'document_customer_header:manage_layouts',
    DOCUMENT_CUSTOMER_HEADER_CONFIGURE_EXTERNAL: 'document_customer_header:configure_external',
    DOCUMENT_CUSTOMER_HEADER_AUDIT_READ: 'document_customer_header:audit_read',
    DMS_READ: 'dms:read',
    DMS_WRITE: 'dms:write',
    DMS_DELETE: 'dms:delete',
    INVOICE_POST: 'invoice:post',
    INVOICE_CANCEL: 'invoice:cancel',
    PURCHASE_READ: 'purchase:read',
    PURCHASE_WRITE: 'purchase:write',
    PURCHASE_INVOICE_APPROVE: 'purchase:invoice_approve',
    EXPORT_DATEV: 'export:datev',
    EXPORT_INTRASTAT: 'export:intrastat',
    REPORT_READ: 'report:read',
    REPORT_WRITE: 'report:write',
    EMPLOYEE_PERFORMANCE_VIEW: 'employee_performance:view',
    SETTINGS_READ: 'settings:read',
    SETTINGS_WRITE: 'settings:write',
    SETTINGS_MANAGE_TEMPLATES: 'settings:manage_templates',
    CUSTOM_FIELDS_READ: 'custom_fields:read',
    CUSTOM_FIELDS_EDIT: 'custom_fields:edit',
    CUSTOM_FIELDS_PUBLISH: 'custom_fields:publish',
    CUSTOM_FIELDS_IMPORT: 'custom_fields:import',
    CUSTOM_FIELDS_ROLLBACK: 'custom_fields:rollback',
    /** @deprecated Compatibility permission; new assignments use the granular custom-field rights. */
    CUSTOM_FIELDS_MANAGE: 'custom_fields:manage',
    CUSTOM_FIELD_GROUPS_MANAGE: 'custom_field_groups:manage',
    CUSTOM_FIELDS_READ_CONFIDENTIAL: 'custom_fields:read_confidential',
    CUSTOM_FIELDS_WRITE_CONFIDENTIAL: 'custom_fields:write_confidential',
    TRANSLATIONS_GENERATE: 'translations:generate',
    TRANSLATIONS_REVIEW: 'translations:review',
    TRANSLATIONS_GLOSSARY_MANAGE: 'translations:glossary_manage',
    SETUP_READ: 'setup:read',
    SETUP_MANAGE: 'setup:manage',
    SETUP_RELEASE: 'setup:release',
    IMPORTS_READ: 'imports:read',
    IMPORTS_MANAGE: 'imports:manage',
    IMPORTS_EXECUTE: 'imports:execute',
    IMPORTS_ROLLBACK: 'imports:rollback',
    BANKING_READ: 'banking:read',
    BANKING_CONNECT: 'banking:connect',
    BANKING_DISCONNECT: 'banking:disconnect',
    BANKING_SYNC: 'banking:sync',
    BANKING_MANAGE_SETTINGS: 'banking:manage_settings',
    BANKING_RECONCILE: 'banking:reconcile',
    BANKING_POST: 'banking:post',
    BANKING_AUTO_POST: 'banking:auto_post',
    BANKING_REVERSE: 'banking:reverse',
    BANKING_READ_SENSITIVE: 'banking:read_sensitive',
    USER_READ: 'user:read',
    USER_WRITE: 'user:write',
    WHATSAPP_READ: 'whatsapp:read',
    WHATSAPP_SEND: 'whatsapp:send',
    WHATSAPP_ASSIGN: 'whatsapp:assign',
    WHATSAPP_TEMPLATE_MANAGE: 'whatsapp:template_manage',
    WHATSAPP_CONFIG: 'whatsapp:config',
    TELEPHONY_USE: 'telephony:use',
    TELEPHONY_VIEW_OWN_LOGS: 'telephony:view_own_logs',
    TELEPHONY_VIEW_ALL_LOGS: 'telephony:view_all_logs',
    TELEPHONY_VIEW_AI_SUMMARY: 'telephony:view_ai_summary',
    TELEPHONY_EDIT_AI_SUMMARY: 'telephony:edit_ai_summary',
    TELEPHONY_MANAGE_SETTINGS: 'telephony:manage_settings',
    QUESTIONNAIRE_USE: 'questionnaire:use',
    QUESTIONNAIRE_VIEW_OWN_RUNS: 'questionnaire:view_own_runs',
    QUESTIONNAIRE_VIEW_ALL_RUNS: 'questionnaire:view_all_runs',
    QUESTIONNAIRE_MANAGE_TEMPLATES: 'questionnaire:manage_templates',
    QUESTIONNAIRE_EXPORT_RESULTS: 'questionnaire:export_results',
    QUESTIONNAIRE_MANAGE_SETTINGS: 'questionnaire:manage_settings',
    FEEDBACK_MANAGE: 'feedback:manage',
    PRODUCT_SPECIFICATION_READ: 'product_specification:read',
    PRODUCT_SPECIFICATION_WRITE: 'product_specification:write',
    PRODUCT_SPECIFICATION_REVIEW: 'product_specification:review',
    PRODUCT_SPECIFICATION_APPROVE: 'product_specification:approve',
    PRODUCT_SPECIFICATION_PUBLISH: 'product_specification:publish',
    PRODUCT_SPECIFICATION_EXPORT: 'product_specification:export',
    PRODUCT_SPECIFICATION_MANAGE_SCHEMA: 'product_specification:manage_schema',
    PRODUCT_SPECIFICATION_MANAGE_PDF_TEMPLATES: 'product_specification:manage_pdf_templates',
    PRODUCT_SPECIFICATION_MANAGE_SETTINGS: 'product_specification:manage_settings',
    PRODUCT_DEVELOPMENT_READ: 'product_development:read',
    PRODUCT_DEVELOPMENT_WRITE: 'product_development:write',
    RAW_MATERIAL_READ: 'raw_material:read',
    RAW_MATERIAL_WRITE: 'raw_material:write',
    RAW_MATERIAL_APPROVE: 'raw_material:approve',
    RECIPE_READ: 'recipe:read',
    RECIPE_WRITE: 'recipe:write',
    RECIPE_REVIEW: 'recipe:review',
    RECIPE_APPROVE: 'recipe:approve',
    RECIPE_ARCHIVE: 'recipe:archive',
    RECIPE_COSTS: 'recipe:costs',
    DECLARATION_READ: 'declaration:read',
    DECLARATION_WRITE: 'declaration:write',
    DECLARATION_REVIEW: 'declaration:review',
    DECLARATION_APPROVE: 'declaration:approve',
    DECLARATION_PUBLISH: 'declaration:publish',
    DECLARATION_MANAGE_CATALOG: 'declaration:manage_catalog',
    ANALYSIS_READ: 'analysis:read',
    ANALYSIS_WRITE: 'analysis:write',
    ANALYSIS_REVIEW: 'analysis:review',
    ANALYSIS_APPROVE: 'analysis:approve',
    ANALYSIS_CALCULATE: 'analysis:calculate',
    ANALYSIS_MANAGE_PARAMETERS: 'analysis:manage_parameters',
    MANUFACTURING_READ: 'manufacturing:read',
    MANUFACTURING_WRITE: 'manufacturing:write',
    MANUFACTURING_RELEASE: 'manufacturing:release',
    MANUFACTURING_RESERVE: 'manufacturing:reserve',
    MANUFACTURING_CONSUME: 'manufacturing:consume',
    MANUFACTURING_COMPLETE: 'manufacturing:complete',
    MANUFACTURING_COSTS: 'manufacturing:costs',
    TRACEABILITY_READ: 'traceability:read',
    TRACEABILITY_SIMULATE: 'traceability:simulate',
    TRACEABILITY_BLOCK: 'traceability:block',
    TRACEABILITY_EXPORT: 'traceability:export',
    MRP_READ: 'mrp:read',
    MRP_RUN: 'mrp:run',
    MRP_CONFIGURE: 'mrp:configure',
    MRP_CONVERT_PURCHASE: 'mrp:convert_purchase',
    MRP_CONVERT_PRODUCTION: 'mrp:convert_production',
    LABEL_READ: 'label:read',
    LABEL_WRITE: 'label:write',
    LABEL_APPROVE: 'label:approve',
    LABEL_PRINT: 'label:print',
    CHANGE_CONTROL_READ: 'change_control:read',
    CHANGE_CONTROL_WRITE: 'change_control:write',
    CHANGE_CONTROL_REVIEW: 'change_control:review',
    CHANGE_CONTROL_APPROVE: 'change_control:approve',
    NEWSLETTER_READ: 'newsletter:read',
    NEWSLETTER_WRITE: 'newsletter:write',
    NEWSLETTER_MANAGE_RECIPIENTS: 'newsletter:manage_recipients',
    NEWSLETTER_MANAGE_CONSENT: 'newsletter:manage_consent',
    NEWSLETTER_EXPORT_CONSENT: 'newsletter:export_consent',
    NEWSLETTER_MANAGE_SETTINGS: 'newsletter:manage_settings',
    SALES_ASSISTANT_USE: 'sales_assistant:use',
    SALES_TASKS_VIEW_OWN: 'sales_tasks:view_own',
    SALES_TASKS_VIEW_TEAM: 'sales_tasks:view_team',
    SALES_TASKS_ASSIGN: 'sales_tasks:assign',
    SALES_CONTACTS_DOCUMENT: 'sales_contacts:document',
    SALES_RECOMMENDATIONS_SNOOZE: 'sales_recommendations:snooze',
    SALES_RECOMMENDATIONS_EXCLUDE: 'sales_recommendations:exclude',
    SALES_RULES_VIEW: 'sales_rules:view',
    SALES_RULES_MANAGE: 'sales_rules:manage',
    SALES_RULES_SIMULATE: 'sales_rules:simulate',
    SALES_ANALYTICS_TEAM_VIEW: 'sales_analytics:view_team',
    SALES_ANALYTICS_EMPLOYEE_VIEW: 'sales_analytics:view_employee_details',
    SALES_AI_SUMMARIES_CREATE: 'sales_ai_summaries:create',
    CONTACT_PREFERENCES_MANAGE: 'contact_preferences:manage',
    BACKUP_VIEW: 'backup:view',
    BACKUP_CREATE_SETTINGS: 'backup:create_settings',
    BACKUP_CREATE_MASTER_DATA: 'backup:create_master_data',
    BACKUP_CREATE_FULL: 'backup:create_full',
    BACKUP_DOWNLOAD: 'backup:download',
    BACKUP_DELETE: 'backup:delete',
    BACKUP_RESTORE: 'backup:restore',
    BACKUP_RESTORE_DRY_RUN: 'backup:restore_dry_run',
    BACKUP_MANAGE_SETTINGS: 'backup:manage_settings',
    BACKUP_DEPLOYMENT_VIEW: 'backup:view_deployment',
    CUSTOMER_DETAILS_DELETE: 'customer:details_delete',
    CUSTOMER_PRICING_WRITE: 'customer:pricing_write',
    DOCUMENT_DELETE: 'document:delete',
    DOCUMENT_PRICE_OVERRIDE: 'document:price_override',
    SALES_ASSISTANT_DELETE: 'sales_assistant:delete',
};
export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
//# sourceMappingURL=permissions.js.map